import settings from "configs/settings";
import auth from "./auth";
import clg from "./log";

export async function reqAuth(url, data) {

    const renewTokens = (data) => {
        return new Promise((resolve, reject) => {
            fetch(settings.req.baseUrl + settings.req.token, {
                method: 'POST',
                headers: { 'Content-type': 'application/json', 'Authorization': 'Bearer ' + auth.getAccessToken() + '' },
                body: JSON.stringify(data),
            })
                .then(renewResponse => {
                    if (renewResponse.ok) {
                        resolve(renewResponse.json());
                    } else {
                        throw renewResponse.status
                    }
                })
                .catch(error => {
                    auth.logout("EXPIRED_TOKEN");
                    reject({ code: error });
                })
        })
    }

    return new Promise((resolve, reject) => {
        fetch( settings.req.baseUrl + url, {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': 'Bearer ' + auth.getAccessToken() + '' },
            body: JSON.stringify(data),
        })
            .then((response) => {
                if (response.ok) {
                    resolve(response.json());
                } else {
                    //throw response.status;
                    throw response;
                }
            })
            .catch((error) => {

                if (error.status === 401) { //401 HTTP error: lejárt a token
                    if (!auth.getRefreshRequestSent()) { //még NEM ment el a REFRESH kérés
                        auth.setRefreshRequestSent(true);
                        renewTokens({ refresh_token: auth.getRefreshToken() })
                            .then(renewData => { //Miután megérkezett a refresh válasz
                                auth.renewTokens(renewData.data.access_token, renewData.data.refresh_token);
                                auth.setRefreshRequestSent(false);
                                reqAuth(url, data)
                                    .then(resp => {
                                        resolve(resp);
                                    })
                                    .catch(error => {
                                        reject(error);
                                    })
                            })
                    } else { //Már elment a REFRESH kérés
                        const checkFlag = () => {
                            if (auth.getRefreshRequestSent()) { //Várakozik, ameddig nem lesz újra FALSE a flag
                                window.setTimeout(checkFlag, 100);
                            } else {
                                //Eredeti kérés elküldése
                                reqAuth(url, data)
                                    .then(resp => { //Megérkezett a response a várakozás után
                                        resolve(resp);
                                    })
                                    .catch(error => {
                                        reject(error);
                                    })
                            }
                        }
                        checkFlag();
                    }
                    return; //Ha 401-es error van, akkor ne engedje rejectelni a promiset
                }
                /* let errObj = new Object(); */
                //console.log("POST -> ", error);

                let errObj = {};
                errObj.code = error;
                let jsonString = JSON.stringify(errObj);
                reject(jsonString); //Ha nem 401-es error van, akkor REJECT
            });
    });
}

async function req( config ) { //method, url, data

    const cfg = {
        method : ( config.method ? config.method : "POST" ),
        url : ( config.url ? config.url : null ),
        data : ( config.data ? config.data : "" ),
    }

    const _url = settings.req.baseUrl + cfg.url;

    //clg("SEND DATA: ", config, cfg.data)

    return new Promise((resolve, reject) => {
        fetch(_url, {
            method: cfg.method,
            headers: {'Content-type' : 'application/json', 'Authorization' : 'Basic ' + btoa("petacat:-Petacica2021!")},
            body: ( cfg.method === "POST" ? JSON.stringify(cfg.data) : null ),
        })
        .then((response) => {
            if (response.ok) {
                const json = response.json();
                return resolve(json);
            } else throw response;
        })
        .catch((error) => {
            switch (error.status) {
                case 400:
                    error.json().then(body => {
                        reject({
                            ...body,
                            http_status_code : error.status,
                        });
                    });
                    break;
            }
        });
    }).catch(err => {
        throw err;
    })
}

export default req;